import { render, staticRenderFns } from "./DetallePoblacionPlan.vue?vue&type=template&id=0cfee652&scoped=true"
import script from "./DetallePoblacionPlan.vue?vue&type=script&lang=js"
export * from "./DetallePoblacionPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfee652",
  null
  
)

export default component.exports